import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import SEO from '../components/SEO';
 
/* ══════════════════════════════════════════════════════════
   ICONS
══════════════════════════════════════════════════════════ */
const ArrowRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found | BAIREES Global Advisory"
        description="The page you're looking for doesn't exist. Return to BAIREES Global Advisory homepage."
      />
      <div className="nf-page">
        <div className="nf-container">
          
          {/* 404 Number */}
          <div className="nf-code-wrapper">
            <div className="nf-code">4</div>
            <div className="nf-code-divider">
              <div className="nf-circle"></div>
              <div className="nf-circle nf-circle--small"></div>
            </div>
            <div className="nf-code">4</div>
          </div>

          {/* Content */}
          <div className="nf-content">
            <span className="nf-eyebrow">Page Not Found</span>
            <h1 className="nf-title">
              Oops! <span className="nf-gold">Lost in</span> the digital space
            </h1>
            <p className="nf-description">
              The page you're looking for doesn't exist or has been moved. 
              Don't worry — we'll help you find your way back.
            </p>

            {/* Quick Links */}
            <div className="nf-quick-links">
              <Link to="/" className="nf-btn nf-btn--primary">
                <HomeIcon /> Back to Home
              </Link>
              <Link to="/contact" className="nf-btn nf-btn--ghost">
                Contact Us <ArrowRight />
              </Link>
            </div>

            {/* Suggestion Links */}
            <div className="nf-suggestions">
              <p className="nf-suggestions-title">You might be looking for:</p>
              <div className="nf-suggestions-grid">
                <Link to="/impact/ai-readiness" className="nf-suggestion">
                  <span className="nf-suggestion-icon">🤖</span>
                  AI Readiness Assessment
                </Link>
                <Link to="/impact/dt-roadmap" className="nf-suggestion">
                  <span className="nf-suggestion-icon">💻</span>
                  Digital Transformation
                </Link>
                <Link to="/impact/technology-assessment" className="nf-suggestion">
                  <span className="nf-suggestion-icon">⚡</span>
                  Technology Assessment
                </Link>
                <Link to="/approach/ai-strategy" className="nf-suggestion">
                  <span className="nf-suggestion-icon">📋</span>
                  Our Services
                </Link>
                <Link to="/about/vision" className="nf-suggestion">
                  <span className="nf-suggestion-icon">🏢</span>
                  About BAIREES
                </Link>
                <Link to="/contact" className="nf-suggestion">
                  <span className="nf-suggestion-icon">📞</span>
                  Get in Touch
                </Link>
              </div>
            </div>
          </div>

          {/* Decorative elements */}
          <div className="nf-decoration nf-decoration--1"></div>
          <div className="nf-decoration nf-decoration--2"></div>
          <div className="nf-decoration nf-decoration--3"></div>
        </div>
      </div>
    </>
  );
};

export default NotFound;